import React from "react";
import Header from "./Header";
import ApplicantConfig from "../applicants/config/ApplicantConfig";

export default function LayoutApplicantConfig() {
  return (
    <>
      <Header />
      <ApplicantConfig />
    </>
  );
}
